<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { DepositAllocation } from '../../../../Types/invoice'

defineProps<{
  deposits: DepositAllocation[]
}>()

const { n, t } = useI18n()
</script>

<template>
  <div class="table-responsive">
    <table class="table table-striped mb-0">
      <thead>
        <tr>
          <th class="font-weight-bold col-3">{{ t('invoice.label.deposit') }}</th>
          <th class="font-weight-bold col-3">{{ t('invoice.label.status') }}</th>
          <th class="font-weight-bold col-3">{{ t('invoice.label.tax') }}</th>
          <th class="font-weight-bold col-3">{{ t('invoice.label.amount') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="depositAllocation in deposits" :key="depositAllocation.id">
          <td>{{ depositAllocation.deposit.number }}</td>
          <td>{{ t('invoice.status.' + depositAllocation.deposit.status + '.label') }}</td>
          <td>{{ n(Number(depositAllocation.vatAmount), 'currency') }}</td>
          <td>{{ n(Number(depositAllocation.amount), 'currency') }}</td>
        </tr>
        <tr v-if="!deposits?.length">
          <td colspan="4" class="text-center">
            {{ t('invoice.title.emptyDeposits') }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
